import React, {useEffect} from 'react'
import "./PaymentPage.css"
import { ContactUs } from '../../Components'
import { Container, Row, Col } from "react-bootstrap"
import { Payment } from "../../Features"
import Cookies from "js-cookie"

const PaymentPage = ({translations, url}) => {

    // useEffect(() => {
    //     if(!Cookies.get("api_key") && !Cookies.get("api_secret")) {
    //         window.location.href = "/login"
    //     }
    // }, []);
    

    return (
        <div className='payment-page'>
            <Container>
                <Payment translations={translations} url={url}></Payment>
            </Container>
        </div>
        
    )
}

export default PaymentPage